import { queryKeys } from "@/api/queryKeys";
import { OrganizationSpeciesApi } from "@/api/species/OrganizationSpeciesApi";
import { useQuery } from "@tanstack/react-query";

export function useOrganizationSpecies(organizationId: string | undefined) {
  const q = useQuery({
    queryKey: queryKeys.species.organization(organizationId ?? ""),
    queryFn: async () => {
      try {
        const species = await OrganizationSpeciesApi.listActive(organizationId!);
        return { species, failed: false as const };
      } catch (error) {
        console.error("Arten konnten nicht geladen werden.", error);
        return { species: [], failed: true as const };
      }
    },
    enabled: !!organizationId,
    staleTime: 60_000,
    retry: false,
  });
  return {
    species: q.data?.species ?? [],
    loading: q.isLoading,
    listError: q.data?.failed === true,
  };
}
